export default class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.swatches = null;
    this.links = null;
  }

  connectedCallback() {
    this.swatches = this.querySelector('[data-target="swatches"]');
    this.links = this.querySelectorAll('a');
    this.mobile1 = this.querySelector('[data-target="mobile-image-1"]');
    this.desktop1 = this.querySelector('[data-target="desktop-image-1"]');
    this.mobile2 = this.querySelector('[data-target="mobile-image-2"]');
    this.desktop2 = this.querySelector('[data-target="desktop-image-2"]');
    this.featured = this.querySelector('[data-target="featured-image"]');
    this.secondary = this.querySelector('[data-target="secondary-image"]');
    this.primaryBadge = this.querySelector('[data-target="primary-badge"]');
    this.secondaryBadge = this.querySelector('[data-target="secondary-badge"]');
    this.price = this.querySelector('[data-target="price"]');
    this.comparePrice = this.querySelector('[data-target="compare-price"]');

    this.init();
  }

  geteActiveSwatchData(event) {
    if (event.target.type === 'radio') {
      // Get the value of the selected radio button
      const link = event.target.value;
      const mobileImage1 = event.target.getAttribute('data-mobile-image-1');
      const desktopImage1 = event.target.getAttribute('data-desktop-image-1');
      const mobileImage2 = event.target.getAttribute('data-mobile-image-2');
      const desktopImage2 = event.target.getAttribute('data-desktop-image-2');
      const primaryText = event.target.getAttribute('data-primary-badge-text');
      const primaryColor = event.target.getAttribute(
        'data-primary-badge-color',
      );
      const primaryTextColor = event.target.getAttribute(
        'data-primary-badge-text-color',
      );
      const secondaryText = event.target.getAttribute(
        'data-secondary-badge-text',
      );
      const secondaryColor = event.target.getAttribute(
        'data-secondary-badge-color',
      );

      const secondaryTextColor = event.target.getAttribute(
        'data-secondary-badge-text-color',
      );

      const price = event.target.getAttribute('data-price');
      const comparePrice = event.target.getAttribute('data-compare-price');

      this.updateProductCard(
        link,
        mobileImage1,
        desktopImage1,
        mobileImage2,
        desktopImage2,
        primaryText,
        primaryColor,
        primaryTextColor,
        secondaryText,
        secondaryColor,
        secondaryTextColor,
        price,
        comparePrice,
      );
    }
  }

  updateProductCard(
    link,
    mobileImage1,
    desktopImage1,
    mobileImage2,
    desktopImage2,
    primaryText,
    primaryColor,
    primaryTextColor,
    secondaryText,
    secondaryColor,
    secondaryTextColor,
    price,
    comparePrice,
  ) {
    // eslint-disable-next-line no-return-assign, no-param-reassign
    this.links.forEach((item) => (item.href = link));
    this.mobile1.src = mobileImage1;
    this.mobile1.srcset = mobileImage1;
    this.desktop1.src = desktopImage1;
    this.desktop1.srcset = desktopImage1;
    this.featured.src = desktopImage1;
    this.mobile2.src = mobileImage2;
    this.mobile2.srcset = mobileImage2;
    this.desktop2.src = desktopImage2;
    this.desktop2.srcset = desktopImage2;
    this.secondary.src = desktopImage2;

    if (primaryText) {
      this.primaryBadge.textContent = primaryText;
      this.primaryBadge.classList.remove('hidden');
      this.primaryBadge.style.background = primaryColor;
      this.primaryBadge.style.color = primaryTextColor;
    } else {
      this.primaryBadge.classList.add('hidden');
    }

    if (secondaryText) {
      this.secondaryBadge.textContent = secondaryText;
      this.secondaryBadge.classList.remove('hidden');
      this.secondaryBadge.style.background = secondaryColor;
      this.secondaryBadge.style.color = secondaryTextColor;
    } else {
      this.secondaryBadge.classList.add('hidden');
    }

    const isClearanceOrSale =
      primaryText.toLowerCase() === 'clearance' ||
      primaryText.toLowerCase() === 'sale' ||
      secondaryText.toLowerCase() === 'clearance' ||
      secondaryText.toLowerCase() === 'sale';

    this.classList.toggle('sale-product', isClearanceOrSale);

    if (this.price !== price) {
      this.price.textContent = price;
    }

    if (comparePrice && this.comparePrice !== comparePrice) {
      this.comparePrice.classList.remove('hidden');
      // eslint-disable-next-line max-len
      this.comparePrice.innerHTML = `| ${comparePrice} <span class='body-3 text-gray-800'> Comp. Value</span>`;
    } else {
      this.comparePrice.classList.add('hidden');
    }
  }

  init() {
    this.swatches?.addEventListener('change', (event) => {
      this.geteActiveSwatchData(event);
    });
  }
}
